// extracted by mini-css-extract-plugin
module.exports = {"card":"_2LlrwvtkKrcCThq0qMjrTj"};